import React from 'react'
import '../css/login.css'
import { accessUri } from '../spotify'

function Login() {
    return (
        <div className='login'>

            <img
                src="https://getheavy.com/wp-content/uploads/2019/12/spotify2019-830x350.jpg"
                alt=""
            />
            <a href={accessUri}>Login with Spotify</a>



        </div>
    )
}

export default Login